import {RootState} from 'store/store';
import {compPassEventsAdapter} from 'pages/comp-pass/store/event-selection-adapters';

/**
 * Selector to get the selected events for the comp pass being created.
 * @param state
 */
export const selectSelectedEvents = (state: RootState) =>
    state.compPass.passCreation.selectEvents.selectedEvents;

/**
 * Selector to get the number of selected events for the comp pass being created.
 * @param state
 */
export const selectNumberOfSelectedEvents = (state: RootState) =>
    selectSelectedEvents(state).length;

/**
 * Selector to get all available events for selection.
 */
export const {selectAll: selectAllEvents} = compPassEventsAdapter.getSelectors(
    (state: RootState) => state.compPass.passCreation.selectEvents.data.events
);

/**
 * Selector to get the event filter options.
 * @param state
 */
export const selectEventFilterOptions = (state: RootState) =>
    state.compPass.filterOptions;

/**
 * Selector to get the applied event filters.
 * @param state
 */
export const selectEventAppliedFilters = (state: RootState) =>
    state.compPass.passCreation.selectEvents.appliedFilters;

/**
 * Selector to get the event data for the comp pass being created.
 * @param state
 */
export const selectEventData = (state: RootState) =>
    state.compPass.passCreation.selectEvents.data;
